import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import Navbar from "../components/Navbar";

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Navbar />
      <div className="pt-40 pb-24 max-w-3xl mx-auto px-6 md:px-12 text-center">
        <AlertCircle size={48} className="mx-auto text-[color:var(--gold)] mb-8" strokeWidth={1.2} />
        <p className="label-caps text-[color:var(--gold)] mb-4">Paiement annulé</p>
        <h1 data-testid="payment-cancel" className="font-serif text-5xl md:text-6xl text-white mb-6 leading-tight">
          Votre écrin vous <em className="italic text-[color:var(--gold-soft)]">attend</em>.
        </h1>
        <p className="text-white/60 font-light max-w-xl mx-auto mb-12">
          Aucun montant n'a été prélevé. Vos articles sont toujours dans votre panier — vous pouvez finaliser
          votre commande quand vous le souhaitez.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button onClick={() => navigate("/checkout")} data-testid="resume-checkout-btn" className="btn-gold">
            Reprendre le paiement
          </button>
          <button onClick={() => navigate("/")} data-testid="cancel-home-btn" className="btn-outline">
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
